$(document).ready(function(){

	$('.btn--displayList').on('click', function(){
		// -- buttons --
		$('.btn--displayMap').removeClass('active');
		$(this).addClass('active');
		// -- content display --
		$('.cities__list__details').addClass('active');
	});

	$('.btn--displayMap').on('click', function(){
		// -- buttons --
		$('.btn--displayList').removeClass('active');
		$(this).addClass('active');
		// -- content display --
		$('.cities__list__details').removeClass('active');
	});

	$('#filterByDate').on('change',function(){
		const selected = $(this).val();
		const baseUrl = window.location.href.split('?');
		var newUrl = baseUrl[0];
		if (selected != '*') {
			var newUrl = baseUrl[0] + '?date=' + selected;
		}
		window.location.href = newUrl;
	});

});